export default __webpack_public_path__ + "static/BackgroundCTP-63ad33297be1fa0ff4444d61cc5428aa.png";